import { render, staticRenderFns } from "./Account.yaml?vue&type=template&id=5f3b1643&component"
import script from "./Account.yaml?vue&type=script&lang=ts&component"
export * from "./Account.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports